import { Component, effect, inject, OnDestroy, OnInit, signal } from "@angular/core";
import { JobSearchStore } from "../../store/job-search-store";
import { Router } from "@angular/router";
import { Button } from "src/app/shared/components/utils/button/button";
import { FilterResultSection } from "src/app/shared/components/filter-result-section/filter-result-section";
import { CardResult } from "src/app/shared/components/card-result/card-result";
import { Loader } from "src/app/shared/components/loader/loader";
import { Modal } from "src/app/shared/components/utils/modal/modal";
import { TranslocoModule } from "@jsverse/transloco";

@Component({
  selector: "app-job-result-page",
  imports: [Button, FilterResultSection, CardResult, Loader, Modal, TranslocoModule],
  templateUrl: "./job-result-page.html",
  styles: [
    `
      .filters-scrollbar {
        scrollbar-color: var(--color-vinciBlue-600) var(--color-vinciGrey-200);
        scrollbar-width: thin;
      }
    `,
  ],
})
export class JobResultPage implements OnInit, OnDestroy {
  loading = signal<boolean>(false);
  extraResultLoading = signal<boolean>(false);

  jobStore = inject(JobSearchStore);
  router = inject(Router);

  isRequestErrorModalOpen = signal<boolean>(false);

  constructor() {
    effect(() => {
      document.body.style.overflow = this.isRequestErrorModalOpen()
        ? "hidden"
        : "";
    });
  }

  async ngOnInit(): Promise<void> {
    this.loading.set(true);
    try {
      await this.jobStore.loadJobs();
    } catch (error: unknown) {
      if ((error as { status?: number })?.status === 400) {
        console.error(
          "Trop de filtres sélectionnés, veuillez réessayer avec moins de filtres :",
          error
        );
        this.openRequestErrorModal();
      } else {
        console.error(
          "Erreur lors de la récupération des tuiles métier:",
          error
        );
      }
    } finally {
      this.loading.set(false);
    }
  }

  redirectToJobResearch(): void {
    this.router.navigate(["/mobility/jobs-search"]);
  }

  openRequestErrorModal(): void {
    this.isRequestErrorModalOpen.set(true);
  }

  closeRequestErrorModalAndRedirectToJobResearch(): void {
    this.isRequestErrorModalOpen.set(false);
    this.redirectToJobResearch();
  }

  closeRequestErrorModal(): void {
    this.isRequestErrorModalOpen.set(false);
  }

  async loadMoreJobCards(): Promise<void> {
    this.jobStore.pagination().start = this.jobStore.pagination().start + 1;
    try {
      this.extraResultLoading.set(true);
      await this.jobStore.loadMoreJobs();
    } finally {
      this.extraResultLoading.set(false);
    }
  }

  ngOnDestroy() {
    this.jobStore.setResults([]);
    this.jobStore.setPagination(null);
    document.body.style.overflow = "";
  }
}
